import './ProductionStatusDocumentField.style.less'

import { Button, Modal, Spin, message, Row } from 'antd'
import {
  CloudUploadOutlined,
  DeleteFilled,
  LoadingOutlined,
  PaperClipOutlined,
} from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { useMutation, useQuery } from 'react-query'

import Dragger from 'antd/lib/upload/Dragger'
import LoadingSpinner from '@/screens/Order/components/LoadingComponent/LoadingSpinner'
import moment from 'moment'
import HttpRequest from '@/config/axios.config'
import { queryClient } from '@/config/react-query'
import { notificationTaskIdAtom } from '@/jotai/notification.jotai'
import { isEmptyValue } from '@/utils/common'
import { useAtom } from 'jotai'

interface Prop {
  label: string
  productionStatusId: string
}

export function ProductionStatusDocumentField(prop: Prop) {
  const { label, productionStatusId } = prop
  const [visible, setVisible] = useState(false)
  const [fileList, setfileList] = useState([])

  const { data, isLoading, refetch } = useQuery(
    ['documentProductionStatusQuery', productionStatusId],
    () =>
      HttpRequest.get(`/documents/production-statuses/${productionStatusId}`)
  )

  const { data: dataCount, refetch: refetchCount } = useQuery(
    ['documentProductionStatusCount', productionStatusId],
    () =>
      HttpRequest.get(
        `documents/production-statuses/${productionStatusId}/count`
      )
  )

  // const [notificationTask, setNotificationTask] = useAtom(
  //   notificationTaskIdAtom
  // )

  // useEffect(() => {
  //   if (
  //     notificationTask.taskId == taskId &&
  //     !isEmptyValue(notificationTask.documentId)
  //   ) {
  //     setVisible(true)
  //   }
  //   return () => {
  //     setNotificationTask({ taskId: null, documentId: null, commentId: null })
  //   }
  // }, [])

  const _reload = () => {
    setfileList([])
    refetch()
  }

  useEffect(() => {
    if (visible) {
      refetch()
      refetchCount()
    } else _reload()
  }, [visible])

  const uploadMutation = useMutation(
    async (payload: any[]) => {
      let _formData = new FormData()
      payload.forEach((item) => _formData.append('files', item))

      return HttpRequest.post('/medias/multiple/documents', _formData).then(
        (resp) => (resp.data?.data ? resp.data?.data : [])
      )
    },
    {
      onSuccess: () => {},
      onError: () => {},
    }
  )

  const saveMutation = useMutation(
    (payload: any[]) => {
      return HttpRequest.post(
        `/documents/production-statuses/${productionStatusId}`,
        [
          ...payload.map((item) => {
            return {
              external_refrence: productionStatusId,
              table: 'documents',
              name: item?.name ?? '',
              url_path: item?.url ?? '',
              size: item?.size ?? 0,
            }
          }),
        ]
      )
    },
    {
      onSuccess: () => _reload(),
      onError: () => {},
    }
  )

  const _onSave = async () => {
    const result = await uploadMutation.mutateAsync(fileList as any[])
    await saveMutation.mutateAsync(result)
    await queryClient.refetchQueries(['GET_FILES_COUNT', productionStatusId])
    refetchCount()
  }

  const _getFiles = (): {
    Name: string
    Type: string
    Path: string
    CreatedBy: string
    CreatedDate: string
    CreatedByName: string
  }[] => {
    return data && data.data && data.data?.data && data.data?.data?.length
      ? data.data?.data?.map((item) => {
          return {
            Name: item?.name ?? '',
            Type: 'image/jpeg',
            Path: item?.url_path ?? '',
            CreatedBy: item?.created_by?.id ?? '',
            CreatedDate: item?.created_at ?? '',
            CreatedByName: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,
          }
        })
      : []
  }

  const uploadProps = {
    accept:
      '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*',
    onRemove: (file) => {
      const index = fileList.findIndex((item) => item.uid === file.uid)
      const newFileList = fileList.slice()
      if (index !== -1) {
        newFileList.splice(index, 1)
      }
      setfileList(newFileList)
    },
    onChange: (e) => {
      if (e.fileList.length) {
        window.onbeforeunload = () => 'warning'
      } else {
        window.onbeforeunload = undefined
      }
    },
    beforeUpload: (file) => {
      if (file.size > 20000000) {
        message.warn('Can not upload file that is more than 20mb')
        return false
      }

      if (
        !(
          file.type.startsWith('image/') ||
          file.type !== 'application/msword' ||
          file.type !==
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          file.type !== 'application/vnd.ms-excel' ||
          file.type !==
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.type !== 'application/pdf'
        )
      ) {
        message.error(`${file.name} is not an Excel, Word, PDF, or Image file`)
        return false
      }

      setfileList([...fileList, file])
      return false
    },
    showUploadList: {
      showRemoveIcon: true,
      removeIcon: <DeleteFilled />,
    },
    fileList: fileList,
  }

  const dateFormat = (date) => {
    if (moment.isMoment(date)) {
      return date.format('DD MMM YYYY')
    } else {
      return moment(date).format('DD MMM YYYY')
    }
  }

  return (
    <>
      <button
        type="button"
        className="ant-btn ant-btn-link"
        onClick={() => {
          setVisible(true)
        }}
      >
        <div className="document-label-name">
          Documents <p className="count-document-ps">{dataCount?.data?.data}</p>
        </div>
      </button>

      {visible && (
        <Modal
          title={
            <>
              <p className="title">Documents</p>
              <p className="sub-title">{label}</p>
            </>
          }
          width={600}
          open={visible}
          className={`dialog-set-plan`}
          onCancel={() => {
            setVisible(false)
          }}
          footer={[
            <Button
              key="1"
              disabled={uploadMutation.isLoading || saveMutation.isLoading}
              className="dialog-cancel-button default-dialog-button"
              onClick={() => setVisible(false)}
            >
              Cancel
            </Button>,
            <Button
              key="2"
              type="primary"
              className="default-dialog-button"
              disabled={saveMutation.isLoading || uploadMutation.isLoading}
              onClick={_onSave}
            >
              Save
            </Button>,
          ]}
        >
          <Spin
            spinning={
              isLoading || uploadMutation.isLoading || saveMutation.isLoading
            }
            indicator={<LoadingSpinner />}
          >
            <div className="custom-upload">
              {false ? (
                <div className="text-center mt-3">
                  <Spin
                    size="small"
                    indicator={
                      <LoadingOutlined style={{ fontSize: 24 }} spin />
                    }
                  />
                </div>
              ) : (
                <div
                  className={`${_getFiles().length ? 'wrap-upload-list' : ''}`}
                >
                  {_getFiles().map((file: any, index) => {
                    return (
                      <div key={index} className="file-item-container">
                        <Row align={'top'}>
                          <PaperClipOutlined />
                          <div>
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              className="file-item-name"
                              title={file?.Name}
                              href={file?.Path}
                            >
                              {file?.Name}
                            </a>

                            <div className="upload-by-container">
                              By{' '}
                              <span className="uploader-name">
                                {file?.CreatedByName}
                              </span>{' '}
                              {dateFormat(file?.created_date)}
                            </div>
                          </div>
                        </Row>
                      </div>
                    )
                  })}
                </div>
              )}
              <Dragger
                {...uploadProps}
                className="br-1"
                style={{ fontWeight: 600 }}
              >
                <p className="ant-upload-drag-icon">
                  <CloudUploadOutlined />
                </p>
                <p className="ant-upload-text">
                  Click to upload a file or drag and drop it here
                </p>
                <p className="ant-upload-hint text-hint-upload">
                  Excel, Word, PDF or Image (20MB max)
                </p>
              </Dragger>
            </div>
          </Spin>
        </Modal>
      )}
    </>
  )
}
